export const formatBigDecimalIntoString = value => {
  if (value) {
    const [integerPart, decimalPart] = value.toString().split('.');

    // Format the integer part with spaces every 3 digits
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    // If there's a decimal part, append it back
    return decimalPart ? `${formattedInteger},${decimalPart}` : formattedInteger;
  }

  return '0,0';
};
